export enum ENUM_NGAY_NGHI {
    NGAY_NGHI_LE = 1,
    NGAY_LAM_BU = 2
}
